export default __webpack_public_path__ + "static/media/who.6ec30007.svg";